"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlternateLanguageUrl = void 0;
var _shared = require("@ori-appshell/shared");
const getAlternateLanguageUrl = (host, language, publicPathname) => `${host.startsWith('https://') || host.startsWith('http://') ? '' : 'https://'}${host}/${language.default ? '' : `${(0, _shared.getLanguageFromLanguageCode)(language.code)}/`}${publicPathname.charAt(0) === '/' ? publicPathname.slice(1) : publicPathname}`;
exports.getAlternateLanguageUrl = getAlternateLanguageUrl;
